export { default } from './PatientHighRiskIndicator';
